import { alpha, styled } from '@mui/material';
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro';

const opacity = 0.2;

export const StripedDataGrid = styled(DataGridPro)(({ theme }) => ({
  [`& .${gridClasses.row}.odd`]: {
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[200],

    '&.Mui-selected': {
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          opacity + theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity
        )
      }
    }
  },
  [`& .${gridClasses.row}`]: {
    ['&.Mui-selected']: {
      backgroundColor: alpha(theme.palette.primary.main, opacity + theme.palette.action.selectedOpacity)
    },
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, opacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
}));
